import { FC, SVGProps } from 'react'

export const Menu: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M3 6.78261C3 6.35039 3.34538 6 3.77143 6H20.2286C20.6546 6 21 6.35039 21 6.78261C21 7.21483 20.6546 7.56522 20.2286 7.56522H3.77143C3.34538 7.56522 3 7.21483 3 6.78261ZM3 12C3 11.5678 3.34538 11.2174 3.77143 11.2174H20.2286C20.6546 11.2174 21 11.5678 21 12C21 12.4322 20.6546 12.7826 20.2286 12.7826H3.77143C3.34538 12.7826 3 12.4322 3 12ZM3 17.2174C3 16.7852 3.34538 16.4348 3.77143 16.4348H20.2286C20.6546 16.4348 21 16.7852 21 17.2174C21 17.6496 20.6546 18 20.2286 18H3.77143C3.34538 18 3 17.6496 3 17.2174Z"
			fill="currentColor"
		/>
	</svg>
)
